import React from "react";
import "./regionSwitch.css";
import yearGroupIcon from '../../../../assets/numbers.png'
export default function RegionSwitch({ region, setRegion }) {
  const handleChange = (e) => {
    setRegion(e.target.value);
  };

  return (
    <div className="region-dropdown-box">
                 <label htmlFor="curriculumSelect" className="form-label">
               <img 
                   src={yearGroupIcon} 
                   alt="info" 
                   style={{ width: '16px', height: '16px' }} 
               />{" "}
              Curriculum
           </label>

      <select value={region} onChange={handleChange} className="region-select">
        <option value="US">🇺🇸 US Common Core</option>
        <option value="UK">🇬🇧 UK National Curriculum</option>
      </select>
    </div>
  );
}
